/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetCampaignScheduleQueryResponse,
  GetCampaignSchedulePathParams,
  GetCampaignSchedule404,
} from '../types/GetCampaignSchedule'

function getGetCampaignScheduleUrl({
  campaign_id,
}: {
  campaign_id: GetCampaignSchedulePathParams['campaign_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/emailbison/campaigns/${campaign_id}/schedule/` as const,
  }
  return res
}

/**
 * @description Get campaign schedule.
 * Returns:
 * Campaign schedule if exists, null otherwise
 * @summary Get campaign schedule
 * {@link /api/v1/emailbison/campaigns/:campaign_id/schedule/}
 */
export async function getCampaignSchedule(
  {
    campaign_id,
  }: { campaign_id: GetCampaignSchedulePathParams['campaign_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetCampaignScheduleQueryResponse,
    ResponseErrorConfig<GetCampaignSchedule404>,
    unknown
  >({
    method: 'GET',
    url: getGetCampaignScheduleUrl({ campaign_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
